import React, { useState } from "react";

import { Tooltip } from "@my-scoot/component-library-legacy";

import { useStyles } from "./DesktopRow.styles";

import { DataItem } from "../DataItem";

import { IconButton } from "@material-ui/core";

import { ReactComponent as CopyIcon } from "assets/images/copy.svg";
import WhatsappIcon from "assets/vectors/whatsap-broadcast/whatsapp_white.svg";
import { EditRounded as EditIcon } from "@material-ui/icons";

import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";

import classnames from "classnames";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import {
  campaignStepsData,
  WHATSAPP_CAMPAIGN_DESCRIPTIONS,
} from "ui/pages/whatsappBroadcast/whatsappBroadcast.constants";
import {
  getStatusChip,
  whatsappCampaignStatusChoices,
} from "../../../constants";
import RenderPhoneNumber from "../RenderPhoneNumber";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import FooterDataItem from "ui/pages/communications/CustomEmail/components/EmailListItem/components/FooterDataItem";
import {
  getPercentage,
  formatRevenue,
} from "features/Common/utils/common.utils";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import SeeMoreStatsModal from "ui/pages/limitedOffer/seeMoreStatsModal";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import RefreshIcon from "@material-ui/icons/Refresh";
import { statsColumns } from "ui/pages/limitedOffer/seeMoreStatsModalConfig";
import { DRIP_SOURCE } from "ui/pages/communications/CustomEmail/components/EmailListItem/EmailListItem.constants";
import { useRefreshStats } from "utils/hooks/useRefreshStats";
import CircularProgress from "@material-ui/core/CircularProgress";

export const DesktopRow = ({
  data,
  time,
  alternate,
  recipients,
  handlePreview,
  handleDuplicate,
  hasWriteAccess,
  onDelete,
  handleEdit,
  type,
  disableAction,
  getTitle,
}) => {
  const classes = useStyles({});

  const isDraft = type === whatsappCampaignStatusChoices.Drafts;
  const isScheduled = type === whatsappCampaignStatusChoices.Scheduled;

  const [showStatsModal, setShowStatsModal] = useState(false);
  const { handleRefreshStats, loading: refreshLoading } = useRefreshStats();

  const isShowRefreshStat = Boolean(
    data?.expiry_date_and_time &&
      new Date(data.expiry_date_and_time) > new Date()
  );

  return (
    <div
      className={classnames(
        "tw-flex tw-p-[16px_0px_16px_12px] tw-border-[1.5px] tw-border-solid tw-border-[#E7E6E4] tw-rounded-[8px] !tw-bg-white",
        alternate && "tw-bg-[#F3F2F1]",
        !hasWriteAccess && "disable_pointer"
      )}
    >
      <ExlyImage
        className={classnames(
          "tw-h-[24px] tw-w-[24px] tw-pb-[12px] tw-pr-[12px] tw-box-content",
          type !== "past" &&
            "tw-border-b-[2px] tw-border-solid tw-border-l-0 tw-border-r-0 tw-border-t-0 tw-border-[#E7E6E4]"
        )}
        src={WhatsappIcon}
        alt="whatsapp main logo"
      />

      <div className="tw-w-full">
        <div className="tw-flex tw-justify-between">
          <div className="tw-flex-1">
            <div
              className={classnames(
                "tw-flex tw-gap-[20px] tw-font-medium tw-cursor-pointer hover:tw-text-[#493AB1]",
                type !== "past" &&
                  "tw-mb-[10px] tw-border-b-[2px] tw-border-solid tw-border-l-0 tw-border-r-0 tw-border-t-0 tw-border-[#E7E6E4]"
              )}
            >
              <div
                className="tw-text-[#272522] tw-text-[16px] tw-font-medium tw-underline tw-mb-[12px] tw-cursor-pointer tw-max-w-[50vw] tw-truncate hover:tw-text-[#493AB1]"
                onClick={isDraft ? handleEdit : handlePreview}
              >
                To: {data?.audience?.segment?.title || recipients}
              </div>
              {getStatusChip({ type, classes })}
            </div>

            <div className="tw-text-[#272522] tw-text-[16px] tw-mb-[10px]">
              Campaign Name: {data.title}
            </div>
            {getTitle({ time, isDraft, isScheduled, type })}
            {!isDraft && !isScheduled && <RenderPhoneNumber data={data} />}
          </div>

          <div className="tw-mt-[-12px]">
            <div
              className={classnames(
                "tw-border-solid tw-border-[#E7E6E4] tw-border-l-0 tw-border-r-0 tw-border-t-0",
                type !== "past" && "tw-border-b-[2px]"
              )}
            >
              <Tooltip
                arrow
                color="primary"
                placement="top"
                title={isDraft ? "Edit broadcast" : "View broadcast"}
              >
                <IconButton
                  className="!tw-p-[12px]"
                  disabled={isDraft && disableAction}
                  onClick={isDraft ? handleEdit : handlePreview}
                >
                  {isDraft ? <EditIcon /> : <VisibilityIcon />}
                </IconButton>
              </Tooltip>
              <Tooltip
                arrow
                color="primary"
                placement="top"
                title="Duplicate this broadcast"
              >
                <IconButton
                  className="!tw-p-[12px]"
                  onClick={handleDuplicate}
                  disabled={disableAction}
                >
                  <CopyIcon
                    className={classnames(
                      "tw-h-[18px]",
                      disableAction && "tw-opacity-[0.26] tw-grayscale"
                    )}
                  />
                </IconButton>
              </Tooltip>
              {type !== whatsappCampaignStatusChoices.Completed && (
                <IconButton
                  className="!tw-p-[12px] hover:!tw-text-[#d32f2f]"
                  onClick={onDelete}
                >
                  <DeleteRoundedIcon />
                </IconButton>
              )}
            </div>
          </div>
        </div>
        {!isDraft && !isScheduled ? (
          <>
            <hr className="tw-border-none tw-h-[2px] tw-bg-[#E7E6E4] tw-my-[10px]" />
            <div className="tw-flex tw-justify-between tw-items-end">
              <div className="tw-flex tw-gap-[16px]">
                {[
                  [
                    "Sent to",
                    data?.sent_count ?? 0,
                    "tw-text-[#493AB1]",
                    "Number of users to whom the campaign was initiated",
                  ],
                  [
                    "Delivered to",
                    data?.delivered_count ?? 0,
                    "tw-text-[#EDB183]",
                    "Number of users to whom the message was delivered",
                  ],
                  ["Opened By", data?.open_count ?? 0, "tw-text-[#0052CC]"],
                  [
                    "Open rate(%)",
                    getPercentage(data?.open_count ?? 0, data?.sent_count ?? 0),
                    "tw-text-[#0052CC]",
                  ],
                ].map(([title, value, className, tooltip], i, arr) => (
                  <React.Fragment key={title}>
                    {i > 0 && <div className="tw-w-[1.5px] tw-bg-[#C4C4C4]" />}

                    <div className="tw-flex tw-items-end tw-gap-4">
                      <DataItem
                        dataClassName={className}
                        title={title}
                        data={value}
                        tooltip={tooltip}
                      />

                      {i === arr.length - 1 && (
                        <div
                          className="tw-flex tw-items-center tw-text-[16px] tw-self-end tw-text-[#493AB1] tw-font-medium tw-cursor-pointer hover:tw-underline tw-whitespace-nowrap"
                          onClick={() => setShowStatsModal(true)}
                        >
                          <span>See more</span>
                          <KeyboardArrowRightIcon style={{ fontSize: 20 }} />
                        </div>
                      )}
                    </div>
                  </React.Fragment>
                ))}
              </div>
              <div className="tw-flex tw-gap-[6px] tw-mr-[16px] tw-items-center !tw-gap-[15px]">
                <div className="tw-flex">
                  {[
                    [
                      "Bookings",
                      data?.total_bookings_received,
                      "tw-text-[#493AB1]",
                      "Number of bookings recieved for this campaign",
                    ],
                    [
                      "Revenue",
                      formatRevenue(data?.total_revenue),
                      "tw-text-[#00B77A]",
                      "Revenue recieved for this campaign",
                    ],
                  ].map(([title, value, className, tooltip], i) => (
                    <React.Fragment key={title}>
                      {i > 0 ? (
                        <div className="tw-w-[1.5px] tw-bg-[#C4C4C4] tw-mx-[22px]" />
                      ) : null}
                      <FooterDataItem
                        dataClassName={className}
                        titleClassName={className}
                        title={title}
                        data={value}
                        tooltip={tooltip}
                      />
                    </React.Fragment>
                  ))}
                </div>

                <div
                  className={classnames(
                    classes.campaignStep,
                    classes[campaignStepsData[`${data?.status}`]?.className]
                  )}
                >
                  {campaignStepsData[`${data?.status}`]?.label}

                  <Tooltip
                    arrow
                    color="primary"
                    placement="top"
                    title={WHATSAPP_CAMPAIGN_DESCRIPTIONS[`${data?.status}`]}
                  >
                    <InfoIcon style={{ fontSize: 18 }} />
                  </Tooltip>
                </div>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>

      <ExlyModal
        desktopModalWidth="450px"
        className="!tw-px-5"
        open={showStatsModal}
        onClose={() => setShowStatsModal(false)}
        title="All stats and details"
        customFooter={
          isShowRefreshStat ? (
            <div className="tw-w-full tw-p-4">
              <button
                className="tw-w-full tw-border-none tw-flex tw-items-center tw-justify-center tw-gap-2 tw-bg-[#493AB1] tw-text-white tw-rounded-md tw-py-2 tw-font-medium"
                disabled={refreshLoading}
                onClick={() =>
                  handleRefreshStats({
                    isWhatsApp: true,
                    campaignUuid: data?.uuid,
                  })
                }
              >
                <p>Refresh stats</p>
                {refreshLoading ? (
                  <CircularProgress size={18} color="inherit" />
                ) : (
                  <RefreshIcon style={{ fontSize: 18 }} />
                )}
              </button>
            </div>
          ) : (
            <></>
          )
        }
      >
        <SeeMoreStatsModal
          record={data}
          columns={statsColumns(data)}
          isShowRefreshStat={isShowRefreshStat}
          isWhatsApp
          dripSource={DRIP_SOURCE.SALES_AND_MARKETING}
        />
      </ExlyModal>
    </div>
  );
};
